// Touch input for the turn-queue model: a tap on the left/right half
// enqueues one turn; keeping the thumb down keeps enqueueing (game.ts).

import type { DirectionPref } from '@evox/shared';
import type { InputSource } from './keyboard.js';

export function createTouchInput(surface: HTMLElement): InputSource {
  let taps: DirectionPref[] = [];
  let held: DirectionPref | undefined;

  function zone(e: TouchEvent): DirectionPref | undefined {
    const t = e.touches[0];
    if (!t) return undefined;
    const rect = surface.getBoundingClientRect();
    return t.clientX - rect.left < rect.width / 2 ? 'left' : 'right';
  }

  function onStart(e: TouchEvent): void {
    const dir = zone(e);
    if (dir === undefined) return;
    taps.push(dir);
    held = dir;
  }

  function onMove(e: TouchEvent): void {
    const dir = zone(e);
    if (dir !== undefined) held = dir;
  }

  function onEnd(): void {
    held = undefined;
  }

  surface.addEventListener('touchstart', onStart, { passive: true });
  surface.addEventListener('touchmove', onMove, { passive: true });
  surface.addEventListener('touchend', onEnd, { passive: true });
  surface.addEventListener('touchcancel', onEnd, { passive: true });

  return {
    drainTaps() {
      const out = taps;
      taps = [];
      return out;
    },
    getHeld: () => held,
    dispose() {
      surface.removeEventListener('touchstart', onStart);
      surface.removeEventListener('touchmove', onMove);
      surface.removeEventListener('touchend', onEnd);
      surface.removeEventListener('touchcancel', onEnd);
    },
  };
}
